import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#CEEDFF"
      d="M11 11.5a8.5 8.5 0 1 1 8.5 8.5h-10a5.499 5.499 0 0 1-3.889-9.39 5.5 5.5 0 0 1 5.677-1.31"
    />
    <path
      fill="#E2BA2B"
      d="M15.452 19.45a1 1 0 1 1 1.672 1.1L14.854 24h4.434a1 1 0 0 1 .892 1.453l-.056.097-3.288 5a1 1 0 0 1-1.672-1.1L17.433 26H13a1 1 0 0 1-.892-1.453l.056-.096z"
    />
    <path
      fill="#80C4FF"
      d="M15.864 2.723A9.5 9.5 0 1 1 19.5 21h-10A6.499 6.499 0 0 1 4.904 9.904a6.5 6.5 0 0 1 5.515-1.84l.21.034.007-.015a9.5 9.5 0 0 1 .776-1.565l.19-.296a9.5 9.5 0 0 1 4.262-3.499m5.099 1.421A7.5 7.5 0 0 0 12 11.5a1 1 0 1 1-2 0q0-.706.103-1.398l.01-.062-.019-.002a4 4 0 0 0-.296-.03L9.5 10a4.499 4.499 0 1 0 0 9h10a7.5 7.5 0 0 0 6.929-4.63 7.5 7.5 0 0 0-1.626-8.174 7.5 7.5 0 0 0-3.84-2.052"
    />
  </svg>
);
const SvgIconWeatherCloudLightning = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherCloudLightning);
export default Memo;
